import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 会员
export function getMemberList(params) {
  var sign = getRequest(params);
  return request({
    url: '/v4/orders/get_products',
    method: 'get',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}

// 会员下单
export function getMemberOrder(params) {
  var sign = getRequest(params);
  return request({
    url: '/v4/orders/pingpp_charge',
    method: 'post',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}

// 获取支付状态
export function getNotify(id) {
  var sign = getRequest({});
  return request({
    url: `/v4/orders/${id}`,
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}

export function getProvinces() {
  var sign = getRequest({});
  return request({
    url: `/v5/provinces`,
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}
export function getCities(id) {
  var sign = getRequest({});
  return request({
    url: `/v5/cities/${id}`,
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}
export function getDistricts(id) {
  var sign = getRequest({});
  return request({
    url: `/v5/districts/${id}`,
    method: 'get',
    headers: {
      'X-Signature': sign
    }
  })
}

export function getActivityMagazine(params) {
  var sign = getRequest({});
  return request({
    url: `/v5/activityMagazine/isExchange`,
    method: 'get',
    params,
    headers: {
      'X-Signature': sign
    }
  })
}

export function getMagazine(data) {
  var sign = getRequest(data);
  return request({
    url: '/v5/activityMagazine/isExchange',
    method: 'post',
    data,
    headers: {
      'X-Signature': sign
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/member.js